package com.sweetlime.dungeonamigo.model

import com.sweetlime.dungeonamigo.util.LongAsDoubleSerializer
import kotlinx.serialization.Serializable

@Serializable
data class UserProfile(
    val id: String = "",
    val username: String = "",
    val usernameLower: String = "",
    val email: String = "",
    val avatarUrl: String = "",
    val avatarId: String = "",
    val tier: String = "free",   // "free" | "plus"
    @Serializable(with = LongAsDoubleSerializer::class)
    val portraitPrimaryColor: Long = 0xFFD4A843L,
    @Serializable(with = LongAsDoubleSerializer::class)
    val portraitSecondaryColor: Long = 0xFF4A90D9L,
    val sessionsPlayed: Int = 0,
)
